import styled from "styled-components";

export const CompanyButtonContainer = styled.div.attrs({
})`
    width: 100%;
    display: flex;
    gap: 16px;
`;

export const CloseContainer = styled.div.attrs({
})`
    display: flex;
    justify-content: flex-end;
    width: 100%;
`;

export const ModalContainer = styled.div.attrs({
})`
    width: 100%;
    margin: 24px 0;
`;

export const InputContainer = styled.div.attrs({
})`
    margin-top: 24px;
    border-top: 1px solid ${p => p.theme.palette.colors.lightshadow};
    border-bottom: 1px solid ${p => p.theme.palette.colors.lightshadow};
    padding: 24px 0;
    
`;